<div class="calendargrid__container">
  <div *ngFor="let name of ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']" class="day-header">{{ name }}</div>
  <div *ngFor="let day of days" class="calendargrid__day-wrapper">
    <app-calendar-grid-day
      [day]="day"
      [countryEventMap]="events?.get(day.toISODate())"
    ></app-calendar-grid-day>
  </div>
</div>
